import { useEffect, useState } from "react";
import { useAuth, useUser } from "@clerk/clerk-react";
import { BACKEND_URL } from "../constants/api";

const useSubscriptionInfo = () => {
  const [planName, setPlanName] = useState("free");
  const [maxReports, setMaxReportCards] = useState(5);
  const [maxAIGenerations, setMaxAIGenerations] = useState(10);
  const [reportsUsed, setReportCardsUsed] = useState(0);
  const [aiGenerationsUsed, setAiGenerationsUsed] = useState(0);
  const [nextReset, setNextReset] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { isSignedIn, isLoaded } = useUser();
  const { getToken } = useAuth();

  const fetchSubscriptionInfo = async () => {
    try {
      setLoading(true);
      const token = await getToken();
      const response = await fetch(`${BACKEND_URL}api/user/subscription`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Failed to fetch subscription info");

      const data = await response.json();
      setPlanName(data.planName);
      setMaxReportCards(data.maxReports);
      setMaxAIGenerations(data.maxAIGenerations);
      setReportCardsUsed(data.reportsUsed);
      setAiGenerationsUsed(data.aiGenerationsUsed);
      setNextReset(data.nextReset);
    } catch (err) {
      console.error("Error fetching subscription info:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isSignedIn && isLoaded) {
      fetchSubscriptionInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn, isLoaded]);

  return {
    planName,
    maxReports,
    maxAIGenerations,
    reportsUsed,
    aiGenerationsUsed,
    nextReset,
    loading,
    error,
    refetch: fetchSubscriptionInfo,
  };
};

export default useSubscriptionInfo;
